import styles from './Anchor.module.css';
import type { AnchorProps } from './types/AnchorProps';

const Anchor = ({
  children,
  className = '',
  fullWidth = false,
  ...props
}: AnchorProps) => {
  return (
    <a
      className={`${styles.anchor} ${fullWidth ? styles.fullWidth : ''} ${className}`}
      {...props}
    >
      {children}
    </a>
  );
};

export default Anchor;
